import { useTranslation } from 'react-i18next';

import { getInterviewerColor } from '@/lib/interviewerColors';
import { cn } from '@/lib/utils';

import type { SlotBooking } from '@/types/scheduling.types';
import type { EventContentArg } from '@fullcalendar/core';

interface SlotEventContentProps {
  eventInfo: EventContentArg;
}

export function SlotEventContent({ eventInfo }: SlotEventContentProps) {
  const { t } = useTranslation();
  const props = eventInfo.event.extendedProps as {
    interviewerName?: string;
    interviewerUserId?: string;
    bookings?: SlotBooking[];
    capacity?: number;
  };

  if (!props.interviewerUserId) {
    return null;
  }

  const color = getInterviewerColor(props.interviewerUserId);
  const bookingCount = props.bookings?.length ?? 0;

  return (
    <div className='flex flex-col gap-0.5 overflow-hidden px-1 py-0.5'>
      <span className={cn('truncate text-xs font-medium', color.text)}>{props.interviewerName}</span>
      {bookingCount > 0 && (
        <span className='inline-flex w-fit rounded-full bg-gray-100 px-1.5 py-0.5 text-[10px] leading-tight text-gray-600'>
          {t('scheduling.details.booked', { count: bookingCount, capacity: props.capacity })}
        </span>
      )}
    </div>
  );
}
